import {createContext} from "react";

const SummaryContext = createContext({});

export default SummaryContext;